module.exports = __webpack_public_path__ + "images/sd-01-faq-desktop.png";